module.exports = __webpack_public_path__ + "bbec52dfc00a21cb7dbd4f9a1dd2a197.jpg";